"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("./config");
var _UnknownUnitError = _interopRequireDefault(require("../ErrorClasses/UnknownUnitError"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const getAndValidateMultiplier = (from, to) => {
  try {
    const multiplier = _config.TRANSFORM.FROM[from].TO[to];
    if (multiplier !== undefined) {
      return multiplier;
    }
  } catch (e) {
    // If there is an error, catch it and then throw a generic error below
  }
  throw new _UnknownUnitError.default(`Cannot transform from "${from}" to "${to}"`);
};
function transformDistanceToUnits(distance, from, to) {
  const multiplier = getAndValidateMultiplier(from, to);
  return distance * multiplier;
}
var _default = transformDistanceToUnits;
exports.default = _default;